import React, { ReactNode } from 'react';
import { useDealHistories } from '~/hooks/deals/useDealHistories';
import { DealHistory } from '~/models/DealHistory';
import { DealHistoryRow } from '~/components/common/deals/show/main/histories/DealHistoryRow';

type Props = {
  dealId: number;
};

const renderRow = (history: DealHistory): ReactNode => (
  <DealHistoryRow key={history.id} dealHistory={history} />
);

/**
 *
 * @param dealId
 * @constructor
 * @for client
 */
export const DealHistoryClientList: React.FC<Props> = ({ dealId }: Props) => {
  const { data: histories } = useDealHistories().useIndex(dealId);
  if (histories === null) {
    return null;
  }
  return <div>{histories.map(renderRow)}</div>;
};
